import { API_URL } from './Constants';
import ApiService from './ApiService';

class KinhsachPageApi {

    static getAllData = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/kinh-sach/all-data");
        } catch (error) {
        }
    };

    static getAllType = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/kinh-sach/all-type");
        } catch (error) {
        }
    };

    static getListByCat = async (catId) => {
        try {
            let params = {};
            if (catId !== null) {
                params = { catId };
            }
            return await ApiService.getDataWithParams(API_URL + "/kinh-sach/list-by-cat", params);
        } catch (error) {
        }
    };

    static getDataByPostId = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            return await ApiService.getDataWithParams(API_URL + "/kinh-sach/chi-tiet", params);
        } catch (error) {
        }
    };
    
     // --------------- ADMIN -----------------
     static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("parentId", formData.parentId || 0);
        data.append("linkFlipbook", formData.linkFlipbook || "");

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.file) {
            data.append("file", formData.file);
        }
        if (formData.ftpFilePath) {
            data.append("ftpFilePath", formData.ftpFilePath);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/kinh-sach/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("isDeleteFile", formData.isDeleteFile);
        data.append("isDeleteImage", formData.isDeleteImage);
        data.append("parentId", formData.parentId || 0);
        data.append("linkFlipbook", formData.linkFlipbook || "");

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.file) {
            data.append("file", formData.file);
        }
        if (formData.ftpFilePath) {
            data.append("ftpFilePath", formData.ftpFilePath);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/kinh-sach/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietKinhSachAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/kinh-sach/admin/detail", params);
        } catch (error) {
        }
    }

    static getAllPosts = async () => {
        const data = await this.getAllData();
        if (data && typeof data === 'object' && !Array.isArray(data)) {
            return Object.values(data).flat();
        }
        return Array.isArray(data) ? data : [];
    }
}

export default KinhsachPageApi;